/**
 * --------------------------------------------------
 * !!! THIS FILE WAS GENERATED BY GRAPHQL-CODEGEN !!!
 * !!!   DO NOT MODIFY THIS FILE BY YOURSELF      !!!
 * --------------------------------------------------
 */

import * as c from "@hex/common";
import type * as Types from "../../generated/graphqlTypes";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type RequestOrgRoleMutationVariables = Types.Exact<{
  gatedAction: Types.InputMaybe<Types.OrgRoleRequestGatedAction>;
  requestedOrgRole: Types.OrgRole;
  reason: Types.InputMaybe<Types.Scalars["String"]["input"]>;
  requestSource: Types.InputMaybe<Types.OrgRoleRequestSource>;
}>;

export type RequestOrgRoleMutation = {
  readonly __typename: "Mutation";
  readonly requestOrgRole: boolean | null;
};

export type GetOrgDirectorySyncEnabledQueryVariables = Types.Exact<{
  orgId: Types.Scalars["OrgId"]["input"];
}>;

export type GetOrgDirectorySyncEnabledQuery = {
  readonly __typename: "Query";
  readonly orgById: {
    readonly __typename: "Org";
    readonly id: c.OrgId;
    readonly directorySyncEnabled: boolean;
  };
};

export const RequestOrgRoleDocument = /*#__PURE__*/ gql`
  mutation RequestOrgRole(
    $gatedAction: OrgRoleRequestGatedAction
    $requestedOrgRole: OrgRole!
    $reason: String
    $requestSource: OrgRoleRequestSource
  ) {
    requestOrgRole(
      gatedAction: $gatedAction
      requestedOrgRole: $requestedOrgRole
      reason: $reason
      toExplore: false
      requestSource: $requestSource
    )
  }
`;
export type RequestOrgRoleMutationFn = Apollo.MutationFunction<
  RequestOrgRoleMutation,
  RequestOrgRoleMutationVariables
>;

/**
 * __useRequestOrgRoleMutation__
 *
 * To run a mutation, you first call `useRequestOrgRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestOrgRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestOrgRoleMutation, { data, loading, error }] = useRequestOrgRoleMutation({
 *   variables: {
 *      gatedAction: // value for 'gatedAction'
 *      requestedOrgRole: // value for 'requestedOrgRole'
 *      reason: // value for 'reason'
 *      requestSource: // value for 'requestSource'
 *   },
 * });
 */
export function useRequestOrgRoleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RequestOrgRoleMutation,
    RequestOrgRoleMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RequestOrgRoleMutation,
    RequestOrgRoleMutationVariables
  >(RequestOrgRoleDocument, options);
}
export type RequestOrgRoleMutationHookResult = ReturnType<
  typeof useRequestOrgRoleMutation
>;
export type RequestOrgRoleMutationResult =
  Apollo.MutationResult<RequestOrgRoleMutation>;
export type RequestOrgRoleMutationOptions = Apollo.BaseMutationOptions<
  RequestOrgRoleMutation,
  RequestOrgRoleMutationVariables
>;
export const GetOrgDirectorySyncEnabledDocument = /*#__PURE__*/ gql`
  query GetOrgDirectorySyncEnabled($orgId: OrgId!) {
    orgById(orgId: $orgId) {
      id
      directorySyncEnabled
    }
  }
`;

/**
 * __useGetOrgDirectorySyncEnabledQuery__
 *
 * To run a query within a React component, call `useGetOrgDirectorySyncEnabledQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrgDirectorySyncEnabledQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrgDirectorySyncEnabledQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useGetOrgDirectorySyncEnabledQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetOrgDirectorySyncEnabledQuery,
    GetOrgDirectorySyncEnabledQueryVariables
  > &
    (
      | { variables: GetOrgDirectorySyncEnabledQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetOrgDirectorySyncEnabledQuery,
    GetOrgDirectorySyncEnabledQueryVariables
  >(GetOrgDirectorySyncEnabledDocument, options);
}
export function useGetOrgDirectorySyncEnabledLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetOrgDirectorySyncEnabledQuery,
    GetOrgDirectorySyncEnabledQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetOrgDirectorySyncEnabledQuery,
    GetOrgDirectorySyncEnabledQueryVariables
  >(GetOrgDirectorySyncEnabledDocument, options);
}
export function useGetOrgDirectorySyncEnabledSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetOrgDirectorySyncEnabledQuery,
    GetOrgDirectorySyncEnabledQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetOrgDirectorySyncEnabledQuery,
    GetOrgDirectorySyncEnabledQueryVariables
  >(GetOrgDirectorySyncEnabledDocument, options);
}
export type GetOrgDirectorySyncEnabledQueryHookResult = ReturnType<
  typeof useGetOrgDirectorySyncEnabledQuery
>;
export type GetOrgDirectorySyncEnabledLazyQueryHookResult = ReturnType<
  typeof useGetOrgDirectorySyncEnabledLazyQuery
>;
export type GetOrgDirectorySyncEnabledSuspenseQueryHookResult = ReturnType<
  typeof useGetOrgDirectorySyncEnabledSuspenseQuery
>;
export type GetOrgDirectorySyncEnabledQueryResult = Apollo.QueryResult<
  GetOrgDirectorySyncEnabledQuery,
  GetOrgDirectorySyncEnabledQueryVariables
>;
